import type { AnswerKey, CostCalculatorStorage } from "../calculator.types";

import { costRanges } from "./cost-ranges";

export function calculateCost(
  answers: CostCalculatorStorage["answers"],
): CostCalculatorStorage["cost"] | null {
  if (!answers) {
    throw new Error("No answers provided");
  }

  const requiredAnswerKeys = [
    "state",
    "practice",
    "subPractice",
    "legalPapers",
  ] as AnswerKey[];

  if (answers.subPractice !== "else") {
    requiredAnswerKeys.push("serviceType");
  }

  const filteredAnswers = (Object.keys(answers) as AnswerKey[])
    .filter((key) => requiredAnswerKeys.includes(key) && answers[key])
    .reduce(
      (acc: Record<string, string | boolean | undefined>, key: AnswerKey) => {
        acc[key] = answers[key];
        return acc;
      },
      {} as Record<string, string | boolean | undefined>,
    );

  if (Object.keys(filteredAnswers).length !== requiredAnswerKeys.length) {
    throw new Error("Not all required answers provided");
  }

  const { state, practice, subPractice, serviceType, legalPapers } =
    filteredAnswers;

  const patterns = [
    `${state}|${practice}|${subPractice}|${serviceType}|${legalPapers}`,
    `${state}|${practice}|${subPractice}|${serviceType}|*`,
    `${state}|${practice}|${subPractice}|*|*`,
  ];

  const pattern = patterns.find((pattern) => {
    return costRanges[pattern as keyof typeof costRanges];
  });

  if (!pattern) {
    return null;
  }

  return costRanges[pattern as keyof typeof costRanges];
}
